import React from 'react';
import styles from './Tab.module.scss';

function Tab(props) {
    const { className = '', selected = false, disabled = false, children, onClick, primary, secondary } = props;

    return (
        <button
            type="button"
            className={[className, styles.Tab, selected ? styles.selected : '', primary ? styles.primaryColor : '', secondary ? styles.secondaryColor : ''].join(' ')}
            disabled={disabled}
            onClick={onClick}>
            {children}
        </button>
    );
}

export default Tab;
